<div class="loader-container" role="status" aria-label="Carregando">
  <span class="brand-logo loader-brand" aria-hidden="true"></span>
  <div class="loader"></div>
</div>
